import React, { useCallback, useEffect, useRef } from 'react';
import { getString } from '../../constants/Strings';
import { sendRioEvent, SpecType, SubType } from '@chegg/commerce-utils';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { PaymentTopHeader } from '../PaymentViews/styled';
import { UpiContainer } from './styled';
import UpiForm from './UpiForm';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { sendRioEventCallback } from '../../utils/CallbackUtils';
import MessageBox from '../MessageBox/MessageBox';
import UpiProcessing from './UpiProcessing';

/*
  This component is the UPI PM form wrapper. It renders the Order header and the UPI form
 */
var UpiOption = function UpiOption() {
  var config = useAppSelector(configSelector);
  var rioNamespace = config.rioNamespace,
    showHeading = config.showHeading,
    headingText = config.headingText,
    initialHeadingLevel = config.initialHeadingLevel;
  var focusRef = useRef(null);
  useEffect(function () {
    sendRioEvent({
      info: getString('APP.RIO.EVENTS.EL_NAME.PM_LOADED'),
      specType: SpecType.COMPONENT_VIEW,
      subType: SubType.COMPONENT,
      callback: sendRioEventCallback,
      namespace: rioNamespace,
      force: false,
      value: getString('APP.RIO.EVENTS.EL_NAME.PM_LOADED_UPI.VALUE')
    });
    if (focusRef.current) focusRef.current.focus();
  }, [rioNamespace]);
  var getHeader = useCallback(function () {
    if (!showHeading || !headingText) return null;
    return /*#__PURE__*/React.createElement(PaymentTopHeader, {
      "data-test": DataTestAttributes.UPI_OPTIONS_HEADER,
      "aria-level": initialHeadingLevel
    }, headingText);
  }, [showHeading, headingText, initialHeadingLevel]);
  return /*#__PURE__*/React.createElement(UpiContainer, {
    ref: focusRef,
    tabIndex: -1,
    "data-test": DataTestAttributes.UPI_OPTIONS
  }, getHeader(), /*#__PURE__*/React.createElement(MessageBox, null), /*#__PURE__*/React.createElement(UpiForm, null), /*#__PURE__*/React.createElement(UpiProcessing, null));
};
export default /*#__PURE__*/React.memo(UpiOption);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UpiOption/UpiOption.js
// module id = 4590
// module chunks = 11